import React from 'react'

import { FilterBar, SortDropdown } from '../ProductListFilter'

function DesktopFilter(props) {
  return (
    <div className="d-flex flex-row justify-content-between align-items-start my-3">
      <FilterBar {...props} />

      <SortDropdown {...props} />
    </div>
  )
}

export default DesktopFilter
